<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,8C12,7.65,11.809999999999999,7.36,11.54,7.18C11.54,7.18,11.55,7.16,11.55,7.16C11.55,7.16,5.55,3.16,5.55,3.16C5.55,3.16,5.54,3.18,5.54,3.18C5.39,3.08,5.21,3,5,3C4.45,3,4,3.45,4,4C4,4,4,12,4,12C4,12.55,4.45,13,5,13C5.21,13,5.39,12.92,5.54,12.82C5.54,12.82,5.55,12.84,5.55,12.84C5.55,12.84,11.55,8.84,11.55,8.84C11.55,8.84,11.54,8.82,11.54,8.82C11.809999999999999,8.64,12,8.35,12,8C12,8,12,8,12,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Play',
} as DefineComponent
</script>
